import React, { useState } from 'react';
import { Search } from '@mui/icons-material';
import { Card, CardContent, Container, InputAdornment, List, ListItem, TextField, Typography } from '@mui/material';
import styles from './PractitionerDirectory.module.css';

const PractitionerDirectory = ({ practitioners }) => {
  const [searchText, setSearchText] = useState('');

  const filteredPractitioners = practitioners.filter((practitioner) =>
    practitioner.name.toLowerCase().includes(searchText.toLowerCase())
  );

  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
  };

  return (
    <Container className={styles.container} sx={{ padding: "0 !important", maxWidth: "100% !important" }}>
      <div className={styles.searchMenu}>
        <h1>Practitioner Directory</h1>
        <TextField
          label="Search"
          variant="outlined"
          fullWidth
          margin="normal"
          value={searchText}
          color='success'
          onChange={(e) => setSearchText(e.target.value)}
          InputProps={{
            startAdornment: (
              <Search sx={{ color: 'action.disabled' }} />
            ),
          }}
        />
      </div>
      <List style={{ display: 'flex', flexWrap: 'wrap' }}>
        {filteredPractitioners.map((practitioner, index) => (
          <ListItem key={index} className={styles.listItem}>
            <Card variant="outlined" className={styles.card}>
              <CardContent>
                <Typography variant="h5">{practitioner.name}</Typography>
                <Typography variant="subtitle1" color="textSecondary">
                  Specialty: {practitioner.specialty}
                </Typography>
                <Typography variant="body2">Location: {practitioner.location}</Typography>
                <Typography variant="body2">Contact: {practitioner.contact}</Typography>
              </CardContent>
            </Card>
          </ListItem>
        ))}
      </List>
    </Container>
  );
};

export default PractitionerDirectory;
